module.exports = __webpack_public_path__ + "img/IMG_1867_L_Black_MockedUp.4770a689.jpg";